import { addCoordinatesToLocations } from './clientGeocoding';

export const enhanceLocationsWithCoordinates = async (locations) => {
	const enriched = await addCoordinatesToLocations(locations);

	const hasNewCoordinates = enriched.some((loc, index) => {
		const original = locations[index];
		return (
			original &&
			!original.latitude &&
			!original.longitude &&
			loc.latitude &&
			loc.longitude
		);
	});

	return { enriched, hasNewCoordinates };
};
